export const PRODUCT = {
  name: "Convoful",
  brandMark: "C",
  libraryTitle: "Library",
  webDeviceLabel: "Convoful web",
} as const;

export const AUTH_COMPLETE_ROUTE = "/auth/complete";
export const TERMS_ROUTE = "/terms";

export const WEB_ROUTES = {
  canonicalOrigin: "https://convoful.com",
  marketing: "/",
  howBuilt: "/how-i-built-this",
  roadmap: "/roadmap",
  privacy: "/privacy",
  support: "/support",
  app: "/app",
  markAttention: "/for-mark",
  appStoreRelease: "/for-mark/app-store",
  userActivities: "/for-mark/user-activities",
  designReview: "/for-mark/design",
  markPrompts: "/how-i-built-this/mark-prompts",
  apiBase: "/api/v1",
} as const;

export function apiRoute(path: `/${string}`): string {
  return `${WEB_ROUTES.apiBase}${path}`;
}

export function appRoute(search = ""): string {
  return `${WEB_ROUTES.app}${search}`;
}

export const PRIVACY_COPY = {
  privateNotes: "Notes · only you",
  privateSummary: "Private human summary · only you",
  privateTerms: "Private search terms · only you",
} as const;
